/**
 * EmailJS Configuration
 * 
 * Replace these values with your own EmailJS credentials.
 * See .env.example for instructions on how to get these values.
 * 
 * For production, use environment variables:
 * - import.meta.env.VITE_EMAILJS_PUBLIC_KEY
 * - import.meta.env.VITE_EMAILJS_SERVICE_ID
 * - etc.
 */

export const EMAILJS_CONFIG = {
  // Your EmailJS Public Key (Account > API Keys)
  PUBLIC_KEY: import.meta.env.VITE_EMAILJS_PUBLIC_KEY || '',
  
  // Your EmailJS Service ID (Email Services)
  SERVICE_ID: import.meta.env.VITE_EMAILJS_SERVICE_ID || '',
  
  // Your EmailJS Template ID (Email Templates)
  TEMPLATE_ID: import.meta.env.VITE_EMAILJS_TEMPLATE_ID || '',
  
  // Email to receive inquiries
  RECIPIENT_EMAIL: import.meta.env.VITE_RECIPIENT_EMAIL || '',
  
  // Debug mode - logs email attempts to console
  DEBUG_MODE: import.meta.env.VITE_DEBUG_MODE === 'true' || false
}

/**
 * Check if EmailJS is configured
 */
export const isEmailJSConfigured = () => {
  return Boolean(
    EMAILJS_CONFIG.PUBLIC_KEY &&
    EMAILJS_CONFIG.SERVICE_ID &&
    EMAILJS_CONFIG.TEMPLATE_ID
  )
}
